import React, { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import HtmlReactParser from 'html-react-parser'
import { N2Winners, User } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const MembersThreeStage: React.FC<{
  data: N2Winners[]
  className: any
  img: any
  stage?: number
  expanded: boolean
  onExpand: () => void
}> = ({ data = [], img = [], className, expanded, onExpand = () => {}, stage = 2 }): JSX.Element => {
  const classes = useStyles()

  const smDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  return (
    <Box className={classes.membersThreeStage}>
      <Accordion square={false} id="membersThreeStage" expanded={expanded} onChange={onExpand}>
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
          {stage === 2 ? 'Участники третьего этапа' : stage === 3 ? 'Участники финала' : 'Победители Кубка IRB'}
        </AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            <Box mt={1} mb="10px">
              {data.map((item: N2Winners, index: number) => {
                return (
                  <Box key={`members-three-stage${index}`} className={classes.itemMembers}>
                    <Box className={classes.accessStageName}>
                      {item.command.name
                        ? `Команда «${item.nomination.name}»: ${item.command.name}`
                        : `${item.command.users[0].lastName} ` +
                          `${item.command.users[0].firstName} ` +
                          `${item.command.users[0].middleName}`}
                    </Box>
                    <Box className={classes.accessStageSub}>
                      {!item.command.name &&
                        HtmlReactParser(`${item.command.users[0].subdivision.name},&nbsp;«${item.nomination.name}»`)}
                    </Box>
                    {item.command.users.length > 1 &&
                      item.command.users.map((itemUser: User, indexUser: any) => {
                        return (
                          <Box key={`members-three-stage-users${indexUser}`}>
                            <Box className={classes.accessStageNameItem}>{itemUser.shortName}</Box>
                            <Box className={classes.accessStageSubItem}>{itemUser.subdivision.name}</Box>
                          </Box>
                        )
                      })}
                  </Box>
                )
              })}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  membersThreeStage: {},
  itemMembers: {
    borderBottom: '1px solid #6C6C6C',
    paddingBottom: 12,
    marginBottom: 15,
  },
  accessStageName: {
    fontSize: 18,
    fontWeight: 700,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  accessStageSub: {
    fontSize: 15,
    fontWeight: 500,
    marginBottom: 10,
    [down('md')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      fontSize: 13,
    },
  },
  accessStageNameItem: {
    fontSize: 16,
    fontWeight: 500,
    marginTop: 5,
    marginLeft: 30,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageSubItem: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    marginLeft: 30,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  icon: {},
}))
